import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useGameStore } from '../store/gameStore';
import './MainMenu.css';
function MainMenu() {
    const { user, setCurrentPage, logout } = useGameStore();
    const menuItems = [
        {
            id: 'game-hub',
            title: 'Game Hub',
            description: 'Start battles, manage teams',
            icon: '⚔️'
        },
        {
            id: 'card-library',
            title: 'Card Library',
            description: 'View and draw cards',
            icon: '🎴'
        },
        {
            id: 'team-builder',
            title: 'Team Builder',
            description: 'Organize your teams',
            icon: '👥'
        }
    ];
    return (_jsxs("div", { className: "main-menu", children: [_jsxs("div", { className: "menu-header", children: [_jsxs("h1", { children: ["Welcome, ", user?.username, "!"] }), _jsxs("div", { className: "player-stats", children: [_jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Level" }), _jsx("span", { className: "value", children: user?.level || 1 })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "EXP" }), _jsx("span", { className: "value", children: user?.exp || 0 })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Coins" }), _jsx("span", { className: "value", children: user?.coins || 0 })] }), _jsxs("div", { className: "stat", children: [_jsx("span", { className: "label", children: "Energy" }), _jsxs("span", { className: "value", children: [user?.energy || 0, "/", user?.max_energy || 100] })] })] })] }), _jsxs("div", { className: "menu-content", children: [_jsx("div", { className: "menu-grid", children: menuItems.map((item) => (_jsxs("div", { className: "menu-item", onClick: () => setCurrentPage(item.id), children: [_jsx("div", { className: "item-icon", children: item.icon }), _jsx("h3", { children: item.title }), _jsx("p", { children: item.description })] }, item.id))) }), _jsx("div", { className: "menu-footer", children: _jsx("button", { className: "btn-logout", onClick: logout, children: "Logout" }) })] })] }));
}
export default MainMenu;
